import { UserRole } from "@repo/types";

export enum Platform {
  LYDECKER = 'Lydecker',
  XTND = 'XTND',
}

export enum Action {
  MANAGE = 'manage',
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
}


export interface Permission {
  platform: Platform;
  role: UserRole;
}
